<template>
    <div>
      <AppHeader />
      <AppFilter />
      <AppListVue />
    </div>
</template>

<script>
    import AppFilter from "../components/AppFilter.vue"
    import AppHeader from '../components/SmcHeader.vue'
    import AppListVue from "@/components/AppList.vue";

    export default {
        data(){},
        created() {
            console.log("qmlsdkfqsdf")
        },
        components:{
            AppHeader,
            AppFilter,
            AppListVue
        }
    }
</script>